import { get } from 'lodash';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useSummerHistory } from 'hooks/useSummerHistory';
import { api } from 'services/api';
import { useEffect } from 'react';

const queryKey = 'self';

// API
const fetchSelf = async () => {
  const selfRes = await api.get('/me');

  return selfRes?.data.data;
};

const requestLogout = async () => api.post('/oauth/logout');

// self state and state helpers
// requires passing queryClient due to react rules of hooks
const clearSelf = (queryClient: any) => {
  return queryClient.setQueryData(['self'], null);
};

// requires passing queryClient due to react rules of hooks
export const setSelf = (queryClient: any, self: any) => {
  queryClient.setQueryData(['self'], self);
};

export const useSelf = () => {
  const history = useSummerHistory();

  const queryClient = useQueryClient();
  const result = useQuery({
    queryKey: [queryKey],
    queryFn: fetchSelf,
    retry: false,
  });

  const { isError, error } = result;
  useEffect(() => {
    if (!isError) return;
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    if (get(error, 'response.data.statusCode') === 401) {
      clearSelf(queryClient);
    }
    if (get(error, 'message') === 'Network Error') {
      history.push('/error?isVpn=true');
    }
  }, [error, history, isError, queryClient]);

  return result;
};

export const logoutSelf = async (queryClient: any) => {
  await requestLogout();
  clearSelf(queryClient);
};
